import {
  Body,
  Box,
  Children,
  Space,
  Stack,
  TextChildren,
} from "@dbn/omnichannel-design-system-g4p";
import * as classes from "./PackagesSelection.css";
import { pipe } from "fp-ts/function";
import { array, option } from "fp-ts";
import { PackageFeature, PackageFeatureProps } from "./PackageFeature";

type PackageFeatureGroupProps = {
  label: TextChildren;
  features: Array<PackageFeatureProps>;
  info: option.Option<Children>;
};

export const PackageFeatureGroup = ({
  label,
  features,
  info,
}: PackageFeatureGroupProps) => (
  <Stack column units={2}>
    <Box vAlignContent="center" className={classes.featureGroupContainer}>
      <Body size="small" weight="medium" className={classes.featureGroupLabel}>
        {label}
      </Body>
    </Box>
    {pipe(
      features,
      array.mapWithIndex((i, f) => (
        <PackageFeature {...f} key={`package_feature_${i}`} />
      ))
    )}

    <Box shrink hAlignContent={"left"}>
      {pipe(
        info,
        option.map(info => (
          <>
            <Space units={2} />
            {info}
          </>
        )),
        option.toNullable
      )}
    </Box>
  </Stack>
);
